import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchAllCategoryProducts,
  fetchAllSubCategoryProducts,
  fetchAllSubCategories,
  // fetchAllBrands,
  // fetchAllMaterials,
  fetchThroughSearch,
  fetchThroughBrand,
  getCollection,
  getHomePageCollection,
} from "./listingPageAPI";

const initialState = {
  products: [],
  subCategories: [],
  brands: [],
  ages: [],
  heights: [],
  frameMaterials: [],
  wheelSizes: [],
  brakeTypes: [],
  materials: [],
  status: "idle",
  selectedCategoryID: null,
  homePageCollectionProducts: [],
};

export const fetchAllCategoryProductsAsync = createAsyncThunk(
  "product/fetchAllCategoryProducts",
  async (CategoryID) => {
    const response = await fetchAllCategoryProducts(CategoryID);
    return response?.data;
  }
);
export const fetchAllSubCategoryProductsAsync = createAsyncThunk(
  "product/fetchAllSubCategoryProducts",
  async (SubCategoryID) => {
    const response = await fetchAllSubCategoryProducts(SubCategoryID);
    return response?.data;
  }
);
export const fetchAllSubCategoriesAsync = createAsyncThunk(
  "categories/fetchAllSubCategories",
  async (CategoryID) => {
    const response = await fetchAllSubCategories(CategoryID);
    return response?.data;
  }
);
// export const fetchAllBrandsAsync = createAsyncThunk(
//   "brand/fetchAllBrands",
//   async () => {
//     const response = await fetchAllBrands();
//     return response?.data;
//   }
// );
// export const fetchAllMaterialsAsync = createAsyncThunk(
//   "material/fetchAllMaterials",
//   async () => {
//     const response = await fetchAllMaterials();
//     return response?.data;
//   }
// );
export const fetchThroughSearchAsync = createAsyncThunk(
  "product/fetchThroughSearch",
  async (searchText) => {
    const response = await fetchThroughSearch(searchText);

    return response?.data;
  }
);
export const fetchThroughBrandAsync = createAsyncThunk(
  "product/fetchThroughBrand",
  async (BrandName) => {
    const response = await fetchThroughBrand(BrandName);

    return response?.data;
  }
);

export const getCollectionAsync = createAsyncThunk(
  "product/getCollection",
  async (collection_id) => {
    try {
      const response = await getCollection(collection_id);
      return response?.data;
    } catch (error) {
      throw Error("Failed to get collection");
    }
  }
);

export const getHomePageCollectionAsync = createAsyncThunk(
  "product/getProductCollection",
  async (collection_id) => {
    try {
      const response = await getHomePageCollection(collection_id);
      return response?.data;
    } catch (error) {
      throw Error("Failed to get collection");
    }
  }
);

export const setSelectedCategoryID = (CategoryID) => (dispatch) => {
  dispatch(productSlice.actions.setSelectedCategoryID(CategoryID));
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setSelectedCategoryID: (state, action) => {
      state.selectedCategoryID = action.payload;
    },
    setBrands: (state, action) => {
      state.brands = action.payload;
    },
    setSubCategories: (state, action) => {
      state.subCategories = action.payload;
    },
    setMaterials: (state, action) => {
      state.materials = action.payload;
    },
    setAges: (state, action) => {
      state.ages = action.payload;
    },
    setHeights: (state, action) => {
      state.heights = action.payload;
    },
    setFrameMaterials: (state, action) => {
      state.frameMaterials = action.payload;
    },
    setWheelSizes: (state, action) => {
      state.wheelSizes = action.payload;
    },
    setBrakeTypes: (state, action) => {
      state.brakeTypes = action.payload;
    },
    resetCollectionData: (state) => {
      state.products = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategoryProductsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllCategoryProductsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      })
      .addCase(getCollectionAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCollectionAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      })
      .addCase(getHomePageCollectionAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHomePageCollectionAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.homePageCollectionProducts = action.payload;
      })
      .addCase(fetchAllSubCategoriesAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllSubCategoriesAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.subCategories = action.payload;
      })
      .addCase(fetchAllSubCategoryProductsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllSubCategoryProductsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      })
      // .addCase(fetchAllBrandsAsync.pending, (state) => {
      //   state.status = "loading";
      // })
      // .addCase(fetchAllBrandsAsync.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   state.brands = action.payload;
      // })
      // .addCase(fetchAllMaterialsAsync.pending, (state) => {
      //   state.status = "loading";
      // })
      // .addCase(fetchAllMaterialsAsync.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   state.materials = action.payload;
      // })
      .addCase(fetchThroughSearchAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchThroughSearchAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      })
      .addCase(fetchThroughBrandAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchThroughBrandAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.products = action.payload;
      });
  },
});
export const {
  increment,
  setBrands,
  setMaterials,
  setAges,
  setHeights,
  setFrameMaterials,
  setBrakeTypes,
  setWheelSizes,
  setSubCategories,
  resetCollectionData,
} = productSlice.actions;

export const selectAllCategoryProducts = (state) => state.product.products;
export const selectAllSubCategories = (state) => state.product.subCategories;
export const selectAllBrands = (state) => state.product.brands;
export const selectPreviousCategory = (state) =>
  state.product.selectedCategoryID;
export const selectAllMaterials = (state) => state.product.materials;
export const selectAllAges = (state) => state.product.ages;
export const selectAllHeights = (state) => state.product.heights;
export const selectAllFrameMaterials = (state) => state.product.frameMaterials;
export const selectAllBrakeTypes = (state) => state.product.brakeTypes;
export const selectAllWheelSizes = (state) => state.product.wheelSizes;

export default productSlice.reducer;
